import { FC } from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../redux/slices";
import { Comments } from "./DataSampleViewComments";
import { v4 as uuidv4 } from "uuid";

export const displayCorrectValue = (results: any) => {
  if (results) {
    if (results?.value?.length > 0) {
      return <div>{results?.value}</div>;
    }

    if (results?.details) {
      return results?.details?.map((s: any) => (
        <div key={`${s?.value}${uuidv4()}`}>
          <span className="display-correct-value-container">
            {s?.title ? `${s.title} :` : ""}
          </span>
          {s?.value}
        </div>
      ));
    }
  } else {
    return "";
  }
};

const DataSampleViewRight: FC = () => {
  const [t] = useTranslation("global");
  const ShowComments = false;
  const { sampleViewInfo } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );
  const { isViewerOnly } = useSelector((state: State) => state.Authentication);

  const aggPayloads = sampleViewInfo?.aggPayloads;
  const textsResults = sampleViewInfo?.texts;

  const finalAnalysisResults = aggPayloads
    ? Object.keys(aggPayloads).map((key) => {
        const payloadData = aggPayloads[key];
        const displayName = textsResults?.[key] || key;

        return {
          key: key,
          name: displayName,
          data: payloadData,
        };
      })
    : [];

  const labels = sampleViewInfo?.labels;
  const finalAnnotations = labels
    ? Object.keys(labels).map((key) => {
        const labelData = labels[key];
        const displayName = textsResults?.[key] || key;
        return {
          key: key,
          name: displayName,
          data: labelData,
        };
      })
    : [];

  const annotationContent = finalAnnotations?.map((labelInstances) => {
    return (
      <div
        className="feat-content-annotation"
        key={`name-${labelInstances.key}`}
      >
        {labelInstances.name}
      </div>
    );
  });

  const annotationValues = finalAnnotations?.map((labelInstances) => {
    return (
      <div
        className="feat-content-annotation-value"
        key={`value-${labelInstances.key}`}
      >
        {labelInstances.data}
      </div>
    );
  });

  return (
    <div className="details-right-side">
      <div className="analyse">
        <div className="title-sections-sample-view">
          {t("Data.table.Analyse")}
        </div>
        {finalAnalysisResults.length >= 1 ? (
          finalAnalysisResults?.map((predictionRequest) => {
            return (
              <div
                className="analyse-card"
                key={`${
                  predictionRequest.data.predictionsV2?.shortResult
                    ? predictionRequest.data.predictionsV2?.shortResult
                    : ""
                }${uuidv4()}`}
              >
                <div className="result-title">
                  {`${predictionRequest.name} ${
                    predictionRequest.data.predictionsV2?.shortResult
                      ? predictionRequest.data.predictionsV2?.shortResult
                      : ""
                  }`}
                </div>

                {predictionRequest?.data?.predictionsV2?.detailedResult?.map(
                  (results: any) => {
                    return (
                      <div
                        className="analyse-results"
                        key={`${results?.title}${uuidv4()}`}
                      >
                        <div className="result-1">{results?.title}</div>
                        <div className="result-2">
                          {displayCorrectValue(results)}
                        </div>
                      </div>
                    );
                  },
                )}
              </div>
            );
          })
        ) : (
          <Alert severity="warning" className="mt-4">
            {t("Data.SampleView.No_measures")}
          </Alert>
        )}
      </div>
      <div className="annotations">
        <div className="title-sections-sample-view">
          {t("Data.table.AnnotationName")}
        </div>
        <div className="annotation-container">
          <div key={""} className="annotations-result">
            <div className="annotations-result-values">
              <div className="result-annotation-1">
                {finalAnnotations?.length >= 1 ? annotationContent : ""}
              </div>
              <div className="result-annotation-2">
                {finalAnnotations?.length >= 1 ? annotationValues : ""}
              </div>
            </div>

            {finalAnnotations?.length === 0 ? (
              <Alert severity="warning">
                {t("Data.SampleView.No_annotations")}
              </Alert>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="commentaires">
        <div className="title-sections-sample-view">
          {!isViewerOnly && ShowComments && t("Data.SampleView.Comments")}
        </div>
        <div className="comments-container">{Comments(t)}</div>
      </div>
    </div>
  );
};

export default DataSampleViewRight;
